var _rect, _text, _rect2, _rect3, _circle, _path, _text2, _text3, _circle2, _circle3, _circle4, _rect4, _text4, _text5, _rect5, _text6, _text7, _rect6, _circle5, _path2, _text8, _text9, _rect7, _text0, _path3, _rect8, _text1, _text10, _circle6, _text11, _text12, _circle7, _text13, _text14, _circle8, _text15, _text16, _circle9, _text17, _text18, _rect9, _circle0, _text19, _rect0, _text20, _text21, _rect1, _text22, _text23, _rect10, _text24, _text25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreAfricanFieldInterfaceControllerBridgeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 620,
    height: 1240,
    viewBox: "0 0 620 1240",
    role: "img",
    "aria-label": "FleetCore African field interface mobile bridge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 620,
    height: 1240,
    rx: 42,
    fill: "#07152A",
    stroke: "#29405D"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 58,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1.4
  }, "THE DRIVER CHATS \xB7 FLEETCORE BUILDS THE RECORD")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 92,
    width: 540,
    height: 492,
    rx: 28,
    fill: "#E8F0EC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 92,
    width: 540,
    height: 82,
    rx: 20,
    fill: "#075E54"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 133,
    r: 25,
    fill: "#128C7E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.25 122.25c-1.5 6 4.5 13.5 10.5 15l3.75-3.75-4.5-3-2.25 2.25c-3-1.5-5.25-3.75-6-6l2.25-2.25-3-4.5z",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 1.6500000000000001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 127,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 17,
    fontWeight: 850
  }, "West Shaft Fleet")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 148,
    fill: "#CFF6E1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "FleetCore Controller \xB7 18 participants")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 123,
    r: 3,
    fill: "#FFFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 133,
    r: 3,
    fill: "#FFFFFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 546,
    cy: 143,
    r: 3,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 196,
    width: 364,
    height: 86,
    rx: 16,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 81,
    y: 223,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    dy: 0
  }, "Thabo, you are at the fuel point."), /*#__PURE__*/React.createElement("tspan", {
    x: 81,
    dy: 22
  }, "Are you refuelling FC-217?"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 411,
    y: 271,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "14:18")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 300,
    width: 190,
    height: 56,
    rx: 16,
    fill: "#D8FDD2",
    stroke: "#C7D5CD"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 383,
    y: 327,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 650,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 383,
    dy: 0
  }, "Yes"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 539,
    y: 345,
    textAnchor: "end",
    fill: "#668174",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "14:18 \u2713\u2713")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 376,
    width: 446,
    height: 145,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "#C7D5CD"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 428,
    r: 28,
    fill: "#FFF3DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.9 437.8v-19.599999999999998h12.6v19.599999999999998M99.8 437.8h17.5M104.7 422.4h7v4.8999999999999995h-7zM114.5 421.7l5.6 4.8999999999999995v9.799999999999999c0 3.5 4.8999999999999995 3.5 4.8999999999999995 0v-9.1",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 1.54,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 407,
    fill: "#17251D",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 15,
    fontWeight: 850
  }, "One step at a time")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 155,
    y: 435,
    fill: "#385045",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Photograph the pump before fuelling.")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 458,
    width: 172,
    height: 38,
    rx: 12,
    fill: "#087CFF"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 179,
    y: 483,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 820
  }, "Open camera")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310 614v42m-10-10 10 10 10-10",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 686,
    width: 540,
    height: 390,
    rx: 28,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 730,
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "STRUCTURED FLEETCORE EVENT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 770,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Refuel record \xB7 FC-217")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 810,
    r: 5,
    fill: "#087CFF"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 815,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Driver")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 815,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Thabo Mokoena")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 867,
    r: 5,
    fill: "#30D6A1"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 872,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Vehicle")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 872,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "FC-217 \xB7 GP 42 XX GP")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 924,
    r: 5,
    fill: "#F5AE35"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 929,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Opening mileage")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 929,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "184,263 km")), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 981,
    r: 5,
    fill: "#F54291"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 986,
    fill: "#96ACC5",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 700
  }, "Pump evidence")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 548,
    y: 986,
    textAnchor: "end",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 800
  }, "Photo captured \xB7 67.4 L")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 1021,
    width: 480,
    height: 35,
    rx: 12,
    fill: "#10243E"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 1038,
    r: 5,
    fill: "#30D6A1"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 1043,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 11,
    fontWeight: 760
  }, "The conversation becomes auditable evidence.")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 1108,
    width: 160,
    height: 88,
    rx: 18,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 1142,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "PLAIN")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 1172,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "One clear request")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 1108,
    width: 160,
    height: 88,
    rx: 18,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 238,
    y: 1142,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "PHOTO-LED")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 238,
    y: 1172,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "Show, then confirm")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 1108,
    width: 160,
    height: 88,
    rx: 18,
    fill: "#0B1D35",
    stroke: "#29405D"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 1142,
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "FAMILIAR")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 418,
    y: 1172,
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 760
  }, "Controller-like guidance")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreAfricanFieldInterfaceControllerBridgeMobile);
export default __webpack_public_path__ + "static/media/fleetcore-african-field-interface-controller-bridge-mobile.bb71d9203495dd8e30733d11d2902127.svg";
export { ForwardRef as ReactComponent };